import { cannotEnterXi, isSentOff } from './matchEngine';

// List targets use a separate namespace from the pitch's position IDs.
export function strategyListDrop(
  activeId,
  target,
  squad,
  players,
  { matchRunning, userTeamId } = {}
) {
  const id = String(activeId).split(' ')[0];
  const source = squad.find((player) => player._id === id);
  const incoming = players.find((player) => player._id === id);
  if (!incoming || !target) return null;

  if (target.slot) {
    if (cannotEnterXi(incoming) || source?.current_position === target.slot) {
      return null;
    }
    // Sent-off starters may move between pitch slots but not be displaced off the pitch.
    return { player: incoming, position: target.slot };
  }

  if (target.bench && source) {
    if (isSentOff(source._id, matchRunning, userTeamId)) return null;
    const replacement = players.find((player) => player._id === target.playerId);
    if (replacement) {
      if (cannotEnterXi(replacement)) return null;
      if (isSentOff(source._id, matchRunning, userTeamId)) return null;
      return { player: replacement, position: source.current_position };
    }
    if (isSentOff(id, matchRunning, userTeamId)) return null;
    return { remove: id };
  }
  return null;
}
